import { IMAGES } from "../data";

const ITEMS = [
  { t: "REGULER CLEANING" },
  { t: "Deep Cleaning", it: true },
  { t: "RUMAH" },
  { t: "Apartemen", it: true },
  { t: "KANTOR & RUKO" },
  { t: "Pasca Renovasi", it: true },
];

export default function Marquee() {
  const row = (key, hidden = false) => (
    <div className="mq-row" key={key} aria-hidden={hidden}>
      {ITEMS.map((item) => (
        <span className="mq-item" key={`${key}-${item.t}`}>
          <span className={item.it ? "it" : ""}>{item.t}</span>
          <img src={IMAGES.logoMark} alt="" />
        </span>
      ))}
    </div>
  );
  return (
    <div className="marquee">
      <div className="mq-track">
        {row("a")}
        {row("b", true)}
      </div>
    </div>
  );
}
